import {
  COBALT,
  RARE_EARTHS,
  LITHIUM,
  NICKEL,
  NATURAL_GRAPHITE,
  SUBSCRIPTION_ESG_COBALT,
  SUBSCRIPTION_ESG_LITHIUM,
  SUBSCRIPTION_ESG_NICKEL,
  SUBSCRIPTION_ESG_RARE_EARTHS,
  GRAPHITE,
  SUBSCRIPTION_ESG_GRAPHITE,
  SYNTHETIC_GRAPHITE,
  BATTERY_EMISSIONS_ANALYSER,
  SUBSCRIPTION_ESG_BATTERY_EMISSIONS_ANALYSER,
  SUBSCRIPTION_ESG_SYNTHETIC_GRAPHITE,
  SUBSCRIPTION_ESG_NATURAL_GRAPHITE,
  SUBSCRIPTION_ESG_LITHIUM_ION_BATTERIES,
  LITHIUM_ION_BATTERIES,
} from '~/constants/services/constants'
import {
  getChildrenSidebar,
  getRoute,
  getRoutes,
} from '~/constants/services/methods'

export const ESG_LITHIUM = {
  name: LITHIUM.name,
  slug: LITHIUM.slug,
  subscription: SUBSCRIPTION_ESG_LITHIUM,
  checkbox: LITHIUM.slug,
  routes: getRoutes(LITHIUM.slug, 'reports', false, 'sustainability/overview'),
  overview: getChildrenSidebar(
    [
      {
        name: 'View Product',
        path: `sustainability/overview`,
      },
    ],
    getRoute(LITHIUM.slug),
  ),
}

export const ESG_COBALT = {
  name: COBALT.name,
  slug: COBALT.slug,
  subscription: SUBSCRIPTION_ESG_COBALT,
  checkbox: COBALT.slug,
  routes: getRoutes(COBALT.slug, 'reports', false, 'sustainability/overview'),
  overview: getChildrenSidebar(
    [
      {
        name: 'View Product',
        path: `sustainability/overview`,
      },
    ],
    getRoute(COBALT.slug),
  ),
}

export const ESG_BATTERY_EMISSIONS_ANALYSER = {
  name: BATTERY_EMISSIONS_ANALYSER.name,
  slug: BATTERY_EMISSIONS_ANALYSER.slug,
  subscription: SUBSCRIPTION_ESG_BATTERY_EMISSIONS_ANALYSER,
  checkbox: 'battery-cell',
  routes: getRoutes(
    BATTERY_EMISSIONS_ANALYSER.slug,
    'reports',
    false,
    'sustainability/overview',
  ),
  overview: getChildrenSidebar(
    [
      {
        name: 'View Product',
        path: `sustainability/overview`,
      },
    ],
    getRoute(BATTERY_EMISSIONS_ANALYSER.slug),
  ),
}

export const ESG_NICKEL = {
  name: NICKEL.name,
  slug: NICKEL.slug,
  subscription: SUBSCRIPTION_ESG_NICKEL,
  checkbox: NICKEL.slug,
  routes: getRoutes(NICKEL.slug, 'reports', false, 'sustainability/overview'),
  overview: getChildrenSidebar(
    [
      {
        name: 'View Product',
        path: `sustainability/overview`,
      },
    ],
    getRoute(NICKEL.slug),
  ),
}

export const ESG_NATURAL_GRAPHITE = {
  name: NATURAL_GRAPHITE.name,
  slug: NATURAL_GRAPHITE.slug,
  checkbox: NATURAL_GRAPHITE.slug,
  subscription: SUBSCRIPTION_ESG_NATURAL_GRAPHITE,
  routes: getRoutes(
    NATURAL_GRAPHITE.slug,
    'reports',
    false,
    'sustainability/overview',
  ),
  overview: getChildrenSidebar(
    [
      {
        name: 'View Product',
        path: `sustainability/overview`,
      },
    ],
    getRoute(NATURAL_GRAPHITE.slug),
  ),
}

export const ESG_SYNTHETIC_GRAPHITE = {
  name: SYNTHETIC_GRAPHITE.name,
  slug: SYNTHETIC_GRAPHITE.slug,
  checkbox: SYNTHETIC_GRAPHITE.slug,
  subscription: SUBSCRIPTION_ESG_SYNTHETIC_GRAPHITE,
  routes: getRoutes(
    SYNTHETIC_GRAPHITE.slug,
    'reports',
    false,
    'sustainability/overview',
  ),
  overview: getChildrenSidebar(
    [
      {
        name: 'View Product',
        path: `sustainability/overview`,
      },
    ],
    getRoute(SYNTHETIC_GRAPHITE.slug),
  ),
}

export const ESG_GRAPHITE = {
  name: GRAPHITE.name,
  slug: GRAPHITE.slug,
  subscription: SUBSCRIPTION_ESG_GRAPHITE,
  checkbox: [NATURAL_GRAPHITE.slug, SYNTHETIC_GRAPHITE.slug],
  routes: getRoutes(
    NATURAL_GRAPHITE.slug,
    'reports',
    false,
    'sustainability/overview',
  ),
}

export const ESG_RARE_EARTHS = {
  name: RARE_EARTHS.name,
  slug: RARE_EARTHS.slug,
  subscription: SUBSCRIPTION_ESG_RARE_EARTHS,
  checkbox: RARE_EARTHS.slug,
  routes: getRoutes(
    RARE_EARTHS.slug,
    'reports',
    false,
    'sustainability/overview',
  ),
  overview: getChildrenSidebar(
    [
      {
        name: 'View Product',
        path: `sustainability/overview`,
      },
    ],
    getRoute(RARE_EARTHS.slug),
  ),
}

export const ESG_LITHIUM_ION_BATTERIES = {
  name: LITHIUM_ION_BATTERIES.name,
  slug: LITHIUM_ION_BATTERIES.slug,
  subscription: SUBSCRIPTION_ESG_LITHIUM_ION_BATTERIES,
  checkbox: LITHIUM_ION_BATTERIES.slug,
  routes: getRoutes(
    LITHIUM_ION_BATTERIES.slug,
    'reports',
    false,
    'sustainability/overview',
  ),
  overview: getChildrenSidebar(
    [
      {
        name: 'View Product',
        path: `sustainability/overview`,
      },
    ],
    getRoute(RARE_EARTHS.slug),
  ),
}
